import Payroll from './views/index.vue';

const routes = [
  {
   path: '/payroll', 
   redirect: '/payroll/run/:entity_index/paygroups',
   beforeEnter: (to, from, next) => {
    let authRole = window.localStorage.getItem('userRole');
    if (authRole == 'ADMIN' || authRole == 'TEAMLEADER' || authRole == 'SUPERADMIN') {
      next();
      return;
    }
    next("/restricted");
  },
  },
  {
    path: '/payroll/run/:entity_index/:step_name',
    component: Payroll,
    props: (route) => ({step_name: route.params.step_name, entity_index: route.params.entity_index}),
    beforeEnter: (to, from, next) => {
      let authRole = window.localStorage.getItem('userRole');
      if (authRole == 'ADMIN' || authRole == 'TEAMLEADER' || authRole == 'SUPERADMIN') {
        next();
        return;
      }
      next("/restricted");
    }
  },
  {
    path: '/payroll/run/:entity_index/:step_name/:sub_step',
    component: Payroll,
    props: (route) => ({step_name: route.params.step_name , sub_step: route.params.sub_step,  entity_index: route.params.entity_index }),
    beforeEnter: (to, from, next) => {
      let authRole = window.localStorage.getItem('userRole');
      if (authRole == 'ADMIN' || authRole == 'TEAMLEADER' || authRole == 'SUPERADMIN') {
        next();
        return;
      }
      next("/restricted");
    }
  },
];

export default routes;
